module.exports = __webpack_public_path__ + "img/indethuisstudio.ca443e0f.jpg";